import { byZkxEnv } from '../utils/zkxEnv'

// ZKX fee collector — gas-tank top-ups are plain token transfers to this
// address, and every FeeToken/FeeNative call the wallet builds pays to it.
// It is indexed off-chain by the ZKX gas-tank backend, so it MUST equal that
// backend's `collector` for the environment this build talks to: point a build
// at a collector the backend does not watch and top-ups are never credited
// while every fee instruction is rejected as invalid — silently, since nothing
// on-chain fails. See zkx-wallet-pro docs/gas-tank-frontend-integration.md §2.2
// and docs/gas-tank-prod-contracts.md.
//
// Split per environment on 2026-08-27: the fresh production deployment brought
// its own collector, while the dev backend keeps indexing the original one.
// `uat` mirrors `prod` — it runs against the production backend.
export const FEE_COLLECTOR = byZkxEnv({
  dev: '0xeff04b2EaD20585899C8ab7D0645772727aD4259',
  uat: '0xa3e85EA7f226d8eB8C3C547c49C61A9Cf6791A91',
  prod: '0xa3e85EA7f226d8eB8C3C547c49C61A9Cf6791A91'
})
export const PERMIT_2_ADDRESS = '0x000000000022D473030F116dDEE9F6B43aC78BA3'
export const PANCAKE_SWAP_PERMIT_2_ADDRESS = '0x31c2F6fcFf4F8759b3Bd5Bf0e1084A055615c768'
export const AMBIRE_V1_QUICK_ACC_MANAGER = '0xfF3f6D14DF43c112aB98834Ee1F82083E07c26BF'
export const UNISWAP_UNIVERSAL_ROUTERS: any = {
  1: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
  11155111: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
  8453: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
  42161: '0x5E325eDA8064b456f4781070C0738d849c824258',
  421614: '0x4A7b5Da61326A6379179b40d00F57E5bbDC962c2',
  10: '0xCb1355ff08Ab38bBCE60111F1bb2B784bE25D7e8',
  11155420: '0xD5bBa708b39537d33F2812E5Ea032622456F1A95',
  137: '0xec7BE89e9d109e7e3Fec59c222CF297125FEFda2',
  84532: '0x050E797f3625EC8785265e1d9BDd4799b97528A1',
  56: '0x4Dae2f939ACf50408e13d58534Ff8c2776d45265',
  43114: '0x4Dae2f939ACf50408e13d58534Ff8c2776d45265',
  42220: '0x643770E279d5D0733F21d6DC03A8efbABf3255B4',
  81457: '0x643770E279d5D0733F21d6DC03A8efbABf3255B4'
}
export const SUPPLY_CONTROLLER_ADDR = '0xA69B8074CE03A33B13057B1e9D37DCDE0024Aaff'
export const WALLET_STAKING_ADDR = '0x47Cd7E91C3CBaAF266369fe8518345fc4FC12935'
export const STK_WALLET = '0xE575cC6EC0B5d176127ac61aD2D3d9d19d1aa4a0'
export const WALLET_TOKEN = '0x88800092fF476844f74dC2FC427974BBee2794Ae'
export const UNI_V3_WALLET_WETH_POOL = '0x53bbDF4EA397D17A6F904dC882b3fB78A6875a66'
export const RELAYER_EXECUTOR_ADDRESSES = [
  '0x942f9CE5D9a33a82F88D233AEb3292E680230348',
  '0xCFaFC6BdD1B92E510D5409EE460bb1A712165AA8'
]
export const STAGING_RELAYER_EXECUTOR_ADDRESSES = ['0x706431177041C87BEb1C25Fa29b92057Cb3c7089']
export const PORTFOLIO_TESTS_V2 = {
  addr: '0xae376B42699fDB0D80e9ceE068A4f75ae6d70d85',
  key: '0xD5Cdb05Df16FB0f84a02ebff3405f80e441d7D57',
  factory: '0x26cE6745A633030A6faC5e64e41D21fb6246dc2d',
  bytecode:
    '0x7f00000000000000000000000000000000000000000000000000000000000000027fa85abbdf4f476f0727ae1450f282935c0d57708ae82c281b3fa758db2e21c89b553d602d80604d3d3981f3363d3d373d3d3d363d730f2aa7bcda3d9d210df69a394b6965cb2566c8285af43d82803e903d91602b57fd5bf3',
  salt: '0x0000000000000000000000000000000000000000000000000000000000000000'
}
